/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { Box, Checkbox } from "@mui/material";
import checklistRowStyle from "./checklistRowStyle";

type ChecklistRowProps = {
  checked: boolean;
  isChecked: boolean;
  onChange: () => void;
  label: string;
  description: string;
  name: string;
};

const ChecklistRow = ({ checked, isChecked, onChange, label, description, name }: ChecklistRowProps) => {
  let labelClass = checklistRowStyle.checklistLabel;

  if (checked || isChecked) {
    labelClass = {
      ...labelClass,
      ...checklistRowStyle.checked,
    };
  }

  return (
    <Grid container>
      <Grid item xs={2}>
        <Checkbox checked={checked || isChecked} disabled={checked} onChange={onChange} name={name} />
      </Grid>
      <Grid item xs={10}>
        <Box sx={labelClass}>{label}</Box>
        {!(checked || isChecked) && <Box sx={checklistRowStyle.checklistDescription}>{description}</Box>}
      </Grid>
    </Grid>
  );
};

export default ChecklistRow;
